// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .caseForm {
  background-color: #f6f3f3;
  color: #000;
  padding-left: 20px;
}
.theme-light .caseForm .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-light .caseForm .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-light .caseForm .images .casePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-light .caseForm label {
  margin-bottom: 0.5rem;
  font-size: 1.5em;
}
.theme-light .caseForm .caseContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-light .caseForm .caseContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-light .caseForm .caseContainer {
    padding: 20px;
  }
}
.theme-light .caseForm .caseContainer .cInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: white;
  color: #000;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-light .caseForm .caseContainer .cInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-light .caseForm .caseContainer .cInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-light .caseForm .caseContainer .cInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-light .caseForm .caseContainer .cInfo .center .caseName {
  font-size: xx-large;
  font-weight: 500;
  border-radius: 20%;
  padding: 5px;
  background-color: #f6f3f3;
  z-index: 99;
}
.theme-light .caseForm .caseContainer .cInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-light .caseForm .caseContainer .cInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #555;
}
.theme-light .caseForm .caseContainer .cInfo .center .info .item span {
  font-size: 12px;
}
.theme-light .caseForm .caseContainer .cInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .caseForm .caseContainer .cInfo .center .form-group {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
}
.theme-light .caseForm .caseContainer .cInfo .center .form-group input,
.theme-light .caseForm .caseContainer .cInfo .center .form-group select,
.theme-light .caseForm .caseContainer .cInfo .center .form-group textarea {
  padding: 0.5rem;
  /* Additional input styling if needed */
}
.theme-light .caseForm .caseContainer .cInfo .right button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .caseForm .caseContainer .cInfo .caseButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-light .caseForm .caseContainer .cInfo .caseButtons {
    flex-wrap: wrap;
  }
}
.theme-light .caseForm .caseContainer .cInfo .caseButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .caseForm .caseContainer .cInfo .caseButtons a {
  color: #555;
}
.theme-dark .caseForm {
  background-color: #333;
  color: #fffef9;
  padding-left: 20px;
}
.theme-dark .caseForm .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-dark .caseForm .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-dark .caseForm .images .casePic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-dark .caseForm label {
  margin-bottom: 0.5rem;
  font-size: 1.5em;
}
.theme-dark .caseForm .caseContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-dark .caseForm .caseContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-dark .caseForm .caseContainer {
    padding: 20px;
  }
}
.theme-dark .caseForm .caseContainer .cInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: #222;
  color: #fffef9;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-dark .caseForm .caseContainer .cInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-dark .caseForm .caseContainer .cInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-dark .caseForm .caseContainer .cInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-dark .caseForm .caseContainer .cInfo .center .caseName {
  font-size: xx-large;
  font-weight: 500;
  border-radius: 20%;
  padding: 5px;
  background-color: #333;
  z-index: 99;
}
.theme-dark .caseForm .caseContainer .cInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-dark .caseForm .caseContainer .cInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #d1d0c9;
}
.theme-dark .caseForm .caseContainer .cInfo .center .info .item span {
  font-size: 12px;
}
.theme-dark .caseForm .caseContainer .cInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .caseForm .caseContainer .cInfo .center .form-group {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
}
.theme-dark .caseForm .caseContainer .cInfo .center .form-group input,
.theme-dark .caseForm .caseContainer .cInfo .center .form-group select,
.theme-dark .caseForm .caseContainer .cInfo .center .form-group textarea {
  padding: 0.5rem;
  /* Additional input styling if needed */
}
.theme-dark .caseForm .caseContainer .cInfo .right button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .caseForm .caseContainer .cInfo .caseButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-dark .caseForm .caseContainer .cInfo .caseButtons {
    flex-wrap: wrap;
  }
}
.theme-dark .caseForm .caseContainer .cInfo .caseButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .caseForm .caseContainer .cInfo .caseButtons a {
  color: #d1d0c9;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/cases/caseForm.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAGI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAIM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAFR;AAMI;EACE,qBAAA;EACA,gBAAA;AAJN;AAOI;EACE,kBAAA;AALN;ADWE;ECPE;IAII,aAAA;EAJN;AACF;ADWE;ECZE;IAQI,aAAA;EAHN;AACF;AAKM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAHR;ADbE;ECII;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EAFR;AACF;AAKQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAHV;AAKU;EACE,eAAA;EACA,gBAAA;AAHZ;AAMU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AAJZ;AAQU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AANZ;AAQY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AANd;AAQc;EACE,eAAA;AANhB;AAUU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AARZ;AAWU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AATZ;AAWY;;;EAGE,eAAA;EACA,uCAAA;AATd;AAeU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAbZ;AAiBQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAfV;ADnFE;EC8FM;IAOI,eAAA;EAdV;AACF;AAgBU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAdZ;AAiBU;EACE,WAAA;AAfZ;AD9HI;ECjBA,sBAAA;EACA,cAAA;EACA,kBAAA;AAkJJ;AAjJI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAmJN;AAjJM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAmJR;AAhJM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAkJR;AA9II;EACE,qBAAA;EACA,gBAAA;AAgJN;AA7II;EACE,kBAAA;AA+IN;ADzIE;ECPE;IAII,aAAA;EAgJN;AACF;ADzIE;ECZE;IAQI,aAAA;EAiJN;AACF;AA/IM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAiJR;ADjKE;ECII;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EAkJR;AACF;AA/IQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAiJV;AA/IU;EACE,eAAA;EACA,gBAAA;AAiJZ;AA9IU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAgJZ;AA5IU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA8IZ;AA5IY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA8Id;AA5Ic;EACE,eAAA;AA8IhB;AA1IU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA4IZ;AAzIU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA2IZ;AAzIY;;;EAGE,eAAA;EACA,uCAAA;AA2Id;AArIU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAuIZ;AAnIQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAqIV;ADvOE;EC8FM;IAOI,eAAA;EAsIV;AACF;AApIU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAsIZ;AAnIU;EACE,cAAA;AAqIZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.caseForm {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    color: themed(\"textColor\");\n    padding-left: 20px;\n    .images {\n      width: 100%;\n      height: 300px;\n      position: relative;\n\n      .cover {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .casePic {\n        width: 200px;\n        height: 200px;\n        border-radius: 50%;\n        object-fit: cover;\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: auto;\n        top: 200px;\n      }\n    }\n\n    label {\n      margin-bottom: 0.5rem;\n      font-size: 1.5em;\n    }\n\n    .caseContainer {\n      padding: 20px 70px;\n\n      @include mobile{\n        padding: 10px;\n      }\n\n      @include tablet{\n        padding: 20px;\n      }\n\n      .cInfo {\n        height: 180px;\n        -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        border-radius: 20px;\n        background-color: themed(\"bg\");\n        color: themed(\"textColor\");\n        padding: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 20px;\n\n        @include mobile{\n          flex-direction: column;\n          height: 30vh;\n          padding: 20px;\n          margin-top: 100px;\n        }\n\n        \n        .center {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          span {\n            font-size: 30px;\n            font-weight: 500;\n          }\n\n          .caseName {\n            font-size: xx-large;\n            font-weight: 500;\n            border-radius: 20%;\n            padding: 5px;\n            background-color: themed(\"bgSoft\");\n            z-index: 99;\n          }\n          \n\n          .info {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-around;\n\n            .item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              color: themed(\"textColorSoft\");\n\n              span {\n                font-size: 12px;\n              }\n            }\n          }\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n\n          .form-group {\n            display: flex;\n            flex-direction: row;\n            margin-bottom: 1rem;\n           \n            input,\n            select,\n            textarea {\n              padding: 0.5rem;\n              /* Additional input styling if needed */\n            }\n          }\n        }\n\n        .right {\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n        }\n\n        .caseButtons {\n          flex: 1;\n          display: flex;\n          gap: 10px;\n          align-items: center;\n\n          @include tablet{\n            flex-wrap: wrap;\n          }\n\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n\n          a{\n            color: themed(\"textColorSoft\");\n          }\n        }\n\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
